<script>
import { required } from "vuelidate/lib/validators";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrBirimButceHarcamalari from "@/models/StrBirimButceHarcamalari";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import BirimSecimi from "../../FormComponet/BirimSecimiAnaBirim.vue";

export default {
  mixins: [Api, Sabit, StrBirimButceHarcamalari],
  page: {
    title: "Harcama Giriş Raporları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    formcombobox,
    BirimSecimi
  },
  data() {
    return {
      title: this.$t("StrBirimButceHarcamalariRapor.Title"),
      items: [
        {
          text: this.$t("StrBirimButceHarcamalariRapor.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrBirimButceHarcamalariRapor.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrBirimButceHarcamalariRapor.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      TableData2: [],
      TableDataHedefBazli: {},
      Rapor: 0,
      BirimIdCombobox: [],
      StrDonemIdCombobox: [],
      DonemCombobox: [],
      StrAmacIdCombobox: [],
      IhaleUsulleriIdCombobox: [],
      StrPerformansHedefiIdCombobox: [],
      OnayComboBox: [
        { Id: "True", Value: "Onaylı" },
        { Id: "False", Value: "Onaysız" },
      ],
      TableDisplay: false,
      Filter: {
        BirimId: "",
        StrDonemId: "",
        Donem: "",
        StrAmacId: "",
        IhaleUsulleriId: "",
        StrPerformansHedefiId: "",
        Onay: "",
      },
    };
  },
  validations: {
    Filter: {
      BirimId: {},
      StrDonemId: { required },
      Donem: { required },
      StrAmacId: {},
      IhaleUsulleriId: {},
      StrPerformansHedefiId: {},
      Onay: {},
    },
  },

  methods: {
    Get() {},

    FilterGet() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let Filter ="";

        if(this.Filter.BirimId != null && this.Filter.BirimId != "" )
        Filter=Filter+"&BirimId=" + this.Filter.BirimId ;

        if(this.Filter.StrDonemId != null && this.Filter.StrDonemId != "" )
        Filter=Filter+"&StrDonemId=" + this.Filter.StrDonemId ;

        if(this.Filter.Donem != null && this.Filter.Donem != "" )
        Filter=Filter+"&Donem=" + this.Filter.Donem ;

        if(this.Filter.StrAmacId != null && this.Filter.StrAmacId != "" )
        Filter=Filter+"&StrAmacId=" + this.Filter.StrAmacId ;

        if(this.Filter.IhaleUsulleriId != null && this.Filter.IhaleUsulleriId != "" )
        Filter=Filter+"&IhaleUsulleriId=" + this.Filter.IhaleUsulleriId ;

        if(this.Filter.StrPerformansHedefiId != null && this.Filter.StrPerformansHedefiId != "" )
        Filter=Filter+"&StrPerformansHedefiId=" + this.Filter.StrPerformansHedefiId ;

        if(this.Filter.Onay != null && this.Filter.Onay != "" )
        Filter=Filter+"&Onay=" + this.Filter.Onay ;


        this.ActionsFilterGet({
          Service: "StrBirimButceHarcamalari/GetHarcamaRaporu",
          Page: this.Page,
          Filter: Filter,
        }).then((res) => {
          this.Rapor = 1
          this.TableDisplay = true;
          this.TableData = res.Data.sort(function (a, b) {return a.Aciklama.localeCompare(b.Aciklama);});
          this.TableData2 = this.groupBy(this.TableData, 'Aciklama');
        });
      }
    },
    FilterGetHedefBazli() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let Filter ="";

        if(this.Filter.BirimId != null && this.Filter.BirimId != "" )
        Filter=Filter+"&BirimId=" + this.Filter.BirimId ;

        if(this.Filter.StrDonemId != null && this.Filter.StrDonemId != "" )
        Filter=Filter+"&StrDonemId=" + this.Filter.StrDonemId ;

        if(this.Filter.Donem != null && this.Filter.Donem != "" )
        Filter=Filter+"&Donem=" + this.Filter.Donem ;

        if(this.Filter.StrAmacId != null && this.Filter.StrAmacId != "" )
        Filter=Filter+"&StrAmacId=" + this.Filter.StrAmacId ;

        if(this.Filter.IhaleUsulleriId != null && this.Filter.IhaleUsulleriId != "" )
        Filter=Filter+"&IhaleUsulleriId=" + this.Filter.IhaleUsulleriId ;

        if(this.Filter.StrPerformansHedefiId != null && this.Filter.StrPerformansHedefiId != "" )
        Filter=Filter+"&StrPerformansHedefiId=" + this.Filter.StrPerformansHedefiId ;

        if(this.Filter.Onay != null && this.Filter.Onay != "" )
        Filter=Filter+"&Onay=" + this.Filter.Onay ;


        this.ActionsFilterGet({
          Service: "StrBirimButceHarcamalari/GetStrBirimButceHarcamalariRaporuHedefBazli",
          Page: this.Page,
          Filter: Filter,
        }).then((res) => {
          this.TableDisplay = true;
          this.Rapor = 2
         this.TableDataHedefBazli = res.Data.sort(function (a, b) {return a.Aciklama.localeCompare(b.Aciklama);});
      

        });
      }
    },
    AmacToplamTutar(Data) {
      return Data.reduce(function (total, item) {
        return total + item.Tutar;
      }, 0);
    },
    PerformanHedefSecimiFilter() {
      this.StrPerformansHedefiIdCombobox = [];
      this.Filter.StrPerformansHedefiId = "";
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      let Filter = "&Asc=SiraNo&AmacId=" + this.Filter.StrAmacId;
      this.ActionsFilterGet({
        Service: "StrPerfTablo",
        Page: Page,
        Filter: Filter,
      }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
          this.StrPerformansHedefiIdCombobox.push({
            Id: res.Data[i].Id,
            Value: res.Data[i].Adi,
          });
        }
      });
    },
    AmacSecimFilter(){
      this.FormDataType.Stramacid.ComboDataArray = [];
      this.Filter.StrAmacId = "";
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      let Filter = "&Asc=Aciklama";
      if (this.Filter.StrDonemId!="" && this.Filter.StrDonemId!=null) {
        Filter = Filter + "&DonemId=" + this.Filter.StrDonemId;
      }

      this.ActionsFilterGet({ Service: "StrStratejikAmac", Page: Page, Filter: Filter }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Stramacid.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Aciklama,
        });

        this.StrAmacIdCombobox.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Aciklama,
        });
      }
      });

    },
    groupBy: function (array, key) {
            const result = {};
            array.forEach((item) => {
                if (!result[item[key]]) {
                    result[item[key]] = [];
                }
                result[item[key]].push(item);
            });
            return result;
        },
  },
  computed: {
    SonToplam: function () {
      return this.TableData.reduce(function (total, item) {
        return total + item.Tutar;
      }, 0);
    },
    SonToplam2: function () {
      return this.TableDataHedefBazli.reduce(function (total, item) {
        return total + item.Tutar;
      }, 0);
    },
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    /*
    this.ActionsGet({ Service: "OBirim", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.BirimIdCombobox.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].BirimAdi,
        });
      }
    }); */

    let sorgu = "&Tip=1561";
          let Tip=[];
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
              console.log(res)
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==1 || res.Data[i].Kod==2 ) { 

                        Tip.push(res.Data[i].Id);       

                    } 
                   
                }

                let altsorgu="&UstIdDoluMu=false&Approval=true";

                let tipler="";

                for (var s=0; s<Tip.length; s++){

                    tipler=tipler+"&TipId="+Tip[s];

                }

                altsorgu=altsorgu+tipler;

             

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                  for (var i = 0; i < res.Data.length; i++) {
                        if (
                          this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <=
                            this.Tarih &&
                          this.Tarih <=
                            this.$options.filters.formatDate(res.Data[i].BitisTarihi)
                        ) {
                          if (!res.Data[i].UstId) {
                            this.StrDonemIdCombobox.push({
                              Id: res.Data[i].Id,
                              Value: res.Data[i].Aciklama,
                            }); 
                          }
                        }
                      } 
              });
         
            });

  /*
    this.ActionsFilterGet({
      Service: "StrPerfDonem",
      Page: Page,
      Filter: "&TipId=04691b9c-20f4-41e2-a339-35638fcd8c5e&Approval=true",
    }).then((res) => {
       
      for (var i = 0; i < res.Data.length; i++) {
        if (
          this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <=
            this.Tarih &&
          this.Tarih <=
            this.$options.filters.formatDate(res.Data[i].BitisTarihi)
        ) {
          if (!res.Data[i].UstId) {
            this.StrDonemIdCombobox.push({
              Id: res.Data[i].Id,
              Value: res.Data[i].Aciklama,
            }); 
          }
        }
      } 
 
    }); */



    let yil=new Date().getFullYear()
    for (var i = yil-2; i < yil+5; i++) {
      this.DonemCombobox.push({
        Id: i,
        Value: i,
      });
    }

    


 /*   this.ActionsGet({ Service: "StrStratejikAmac", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.StrAmacIdCombobox.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Aciklama,
        });
      }
    }); */
    this.ActionsSabitGet(1552).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.IhaleUsulleriIdCombobox.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" /> 
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-6">

                <BirimSecimi
                        :title="$t(
                        'StrBirimButceHarcamalariRapor.Filtreleme.BirimId'
                      )"
                        :title_class="'mb-2'"
                        :closeOnSelect="true"
                        :sutun="'0'"
                        :multiple="false"
                        :YetkiKontrol="0"
                        :BirimTipId="null"
                        :v="$v.Filter.BirimId"
                        @Secilmis_Idler="Filter.BirimId=$event"
                      />
                </div>

                <div class="col-sm-6">
                  <formcombobox
                    :FormDataType="{
                      FieldName: 'StrDonemId',
                      Field: 'combobox',
                      FieldTitle: $t(
                        'StrBirimButceHarcamalariRapor.Filtreleme.StrDonemId'
                      ),
                      ComboDataArray: StrDonemIdCombobox,
                    }"
                    :Value="Filter.StrDonemId"
                    :v="$v.Filter.StrDonemId"
                    @input="(Filter.StrDonemId = $event), AmacSecimFilter()"
                  />
                </div>
                <div class="col-sm-6">
                  <formcombobox
                    :FormDataType="{
                      FieldName: 'Donem',
                      Field: 'combobox',
                      FieldTitle: $t(
                        'StrBirimButceHarcamalariRapor.Filtreleme.Donem'
                      ),
                      ComboDataArray: DonemCombobox,
                    }"
                    :Value="Filter.Donem"
                    :v="$v.Filter.Donem"
                    @input="Filter.Donem = $event"
                  />
                </div>
                <div class="col-sm-6">
                  <formcombobox
                    :FormDataType="{
                      FieldName: 'IhaleUsulleriId',
                      Field: 'combobox',
                      FieldTitle: $t(
                        'StrBirimButceHarcamalariRapor.Filtreleme.IhaleUsulleriId'
                      ),
                      ComboDataArray: IhaleUsulleriIdCombobox,
                    }"
                    :Value="Filter.IhaleUsulleriId"
                    :v="$v.Filter.IhaleUsulleriId"
                    @input="Filter.IhaleUsulleriId = $event"
                  />
                </div>
                <div class="col-sm-6">
                  <formcombobox
                    :FormDataType="{
                      FieldName: 'StrAmacId',
                      Field: 'combobox',
                      FieldTitle: $t(
                        'StrBirimButceHarcamalariRapor.Filtreleme.StrAmacId'
                      ),
                      ComboDataArray: StrAmacIdCombobox,
                    }"
                    :Value="Filter.StrAmacId"
                    :v="$v.Filter.StrAmacId"
                    @input="
                      (Filter.StrAmacId = $event), PerformanHedefSecimiFilter()
                    "
                  />
                </div>
                <div class="col-sm-6">
                  <formcombobox
                    :FormDataType="{
                      FieldName: 'StrPerformansHedefiId',
                      Field: 'combobox',
                      FieldTitle: $t(
                        'StrBirimButceHarcamalariRapor.Filtreleme.StrPerformansHedefiId'
                      ),
                      ComboDataArray: StrPerformansHedefiIdCombobox,
                    }"
                    :Value="Filter.StrPerformansHedefiId"
                    :v="$v.Filter.StrPerformansHedefiId"
                    @input="Filter.StrPerformansHedefiId = $event"
                  />
                </div>
                <div class="col-sm-6">
                  <formcombobox
                    :FormDataType="{
                      FieldName: 'Onay',
                      Field: 'combobox',
                      FieldTitle: $t(
                        'StrBirimButceHarcamalariRapor.Filtreleme.Onay'
                      ),
                      ComboDataArray: OnayComboBox,
                    }"
                    :Value="Filter.Onay"
                    :v="$v.Filter.Onay"
                    @input="Filter.Onay = $event"
                  />
                </div>

                <div class="col-sm-6 pt-3">
                  
                  <b-button
                    @click="FilterGet()"
                    class="btn btn-primary"
                    variant="primary"
                    >{{
                      $t("StrBirimButceHarcamalariRapor.Filtreleme.ButtonHarcamaRaporu")
                    }}</b-button
                  >
                  <b-button
                    @click="FilterGetHedefBazli()"
                    class="btn btn-primary mx-2"
                    variant="primary"
                    >{{
                      $t("StrBirimButceHarcamalariRapor.Filtreleme.ButtonHarcamaRaporuHedefBazli")
                    }}</b-button
                  >
                  <b-dropdown variant="success" class="btn btn-rounded me-2">
                    <template v-slot:button-content>
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      {{ $t("StrBirimButceHarcamalari.Page.Yazdir") }}
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item
                      href="javascript: void(0);"
                      @click="ExcelExport('Harcama Giriş', 'Harcama Giriş')"
                    >
                      {{
                        $t("StrBirimButceHarcamalari.Page.ExceleAktar")
                      }}</b-dropdown-item
                    >
                    <b-dropdown-item
                      href="javascript: void(0);"
                      @click="Export2Word('exportContent', 'Harcama Giriş')"
                    >
                      {{
                        $t("StrBirimButceHarcamalari.Page.WordeAktar")
                      }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
              <div id="exportContent">
                  <div  v-if="TableDisplay && Rapor == 1" >
                    <div class="table-responsive" ref="ExcelExportTable">
                      <table   class="table table-borderless mb-0"
                        style="border-collapse: collapse; width: 100%"
                      >
                        <thead>
                          <tr>
                            <th
                              colspan="2"
                              style="border: 1px solid"
                              class="text-sm-center"
                            >
                              {{
                                StrDonemIdCombobox.filter((notification) =>
                                  notification.Id.includes(Filter.StrDonemId)
                                )[0].Value
                              }}
                            </th>
                          </tr>
                        </thead>
                        </table>
                      <table
                        class="table table-borderless mb-0"
                        style="border-collapse: collapse; width: 100%"
                        v-for="(Data, index) in TableData2" :key="index" >
                      <thead>
                          <tr v-if="Data[0].Tutar > 0">
                            <th class="col-md-10" style="border: 1px solid">{{ Data[0].Aciklama }}</th>
                            <th style="border: 1px solid">
                              {{ Filter.Donem }}
                            </th>
                          </tr>
                        </thead>
                          <tbody v-for="(SubData, index2) in Data" :key="index2">
                          <tr v-if="SubData.Tutar > 0">
                            <td>
                              {{ SubData.Birimadi }}
                            </td>
                            <td>
                              {{ SubData.Tutar | TrParaFormat }}
                            </td>
                          </tr>
                        </tbody>
                        <thead>
                          <tr v-if="Data.length > 0" >
                            <th class="col-md-10" style="border: 1px solid">Amaç Bazlı Toplam  </th>
                            <th style="border: 1px solid">
                              {{ AmacToplamTutar(Data) | TrParaFormat }}
                            </th>
                          </tr>
                          <tr v-else>
                            <th  style="text-align: center;"> Kayıt Bulunamadı</th>
                          </tr>
                        </thead>


                      </table>
                      <table
                      class="table table-borderless mb-0"
                        style="border-collapse: collapse; width: 100%"
                      >
                        <thead>
                          <tr v-if="TableData.length > 0" >
                            <th class="col-md-10" style="border: 1px solid">Genel Toplam  </th>
                            <th style="border: 1px solid">
                              {{ SonToplam | TrParaFormat }}
                            </th>
                          </tr>
                          <tr v-else>
                            <th  style="text-align: center;"> Kayıt Bulunamadı</th>
                          </tr>
                        </thead>
                        </table>
                    </div>
                  </div>
                  <div  v-if="TableDisplay  && Rapor == 2">
                    <div class="table-responsive" ref="ExcelExportTable">
                      <table   class="table table-borderless mb-0" 
                        style="border-collapse: collapse; width: 100%; border: 1px solid white;" 
                      >
                        <tbody>
                          <tr>
                            <th style="background-color: rgb(7, 156, 165); font-weight:bold;"
                              colspan="2"
                              class="text-sm-center"
                            >
                              {{
                                StrDonemIdCombobox.filter((notification) =>
                                  notification.Id.includes(Filter.StrDonemId)
                                )[0].Value
                              }}
                            </th>
                          </tr>
                        </tbody>
                        </table>
                      <table
                        class="table table-borderless mb-0"
                        style="border-collapse: collapse; width: 100%; border: 1px solid white;"
                        v-for="(Data2, index) in TableDataHedefBazli" :key="index" >
                      <tbody>
                          <tr v-if="Data2.Tutar > 0">
                            <th class="col-md-10" style="background-color: rgb(7, 156, 165); font-weight:bold;">{{ Data2.Aciklama }}</th>
                            <th style="background-color: rgb(7, 156, 165); font-weight:bold;">
                              {{ Filter.Donem }}
                            </th>
                          </tr>
                        </tbody>
                          <tbody v-for="(SubData, index2) in Data2.Hedef" :key="index2">
                          <tr v-if="SubData.Tutar > 0">
                            <td style="background-color: rgb(174, 240, 243);" >
                           {{ SubData.HedefNo }}   {{ SubData.Hedef }}
                            </td>
                            <td style="background-color: rgb(174, 240, 243);">
                              {{ SubData.Tutar | TrParaFormat }}
                            </td>
                          </tr>
                          <tr v-for="(Faaliyet, index3) in SubData.Faaliyet" :key="index3">
                            <td>
                              {{ Faaliyet.Faaliyet }}
                            </td>
                            <td>
                              {{ Faaliyet.Tutar | TrParaFormat }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr v-if="Data2.Tutar > 0" >
                            <th class="col-md-10" style="background-color: rgb(7, 156, 165); text-align: center; font-weight:bold; border-style: solid;">Amaç Bazlı Toplam  </th>
                            <th style="background-color: rgb(7, 156, 165); text-align: center; font-weight:bold;">
                              {{ Data2.Tutar | TrParaFormat }}
                            </th>
                          </tr>
                          <tr v-else>
                            <th  style="background-color: rgb(7, 156, 165); text-align: center;"> Kayıt Bulunamadı</th>
                          </tr>
                        </tbody>


                      </table>
                      <table
                      class="table table-borderless mb-0"
                        style="border-collapse: collapse; width: 100%"
                      >
                        <tbody>
                          <tr v-if="TableDataHedefBazli.length > 0" >
                            <th class="col-md-10" style="background-color: rgb(7, 156, 165); text-align: center;">Genel Toplam  </th>
                            <th style="background-color: rgb(7, 156, 165); text-align: center; font-weight:bold;">
                              {{ SonToplam2 | TrParaFormat }}
                            </th>
                          </tr>
                          <tr v-else>
                            <th  style="background-color: rgb(7, 156, 165); text-align: center; font-weight:bold;"> Kayıt Bulunamadı</th>
                          </tr>
                        </tbody>
                        </table>
                    </div>
                  </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </Loader>
</template>
